import React from 'react';
import {
  Box,
  Typography,
  Modal,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { ModalImageData } from '../types';

interface RealtimeImageModalProps {
  modalImage: ModalImageData | null;
  imageUpdateKey: number;
  onClose: () => void;
}

const RealtimeImageModal: React.FC<RealtimeImageModalProps> = ({
  modalImage,
  imageUpdateKey,
  onClose,
}) => {
  return (
    <Modal
      open={!!modalImage}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          maxWidth: '90vw',
          maxHeight: '90vh',
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 2,
          outline: 'none',
        }}
      >
        {modalImage && (
          <>
            <Box sx={{ p: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6" component="h2">
                  {modalImage.title}
                </Typography>
                <IconButton onClick={onClose} size="small">
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
            <Box sx={{ p: 2, display: 'flex', justifyContent: 'center' }}>
              <img
                key={`modal-${imageUpdateKey}`}
                src={modalImage.src}
                alt={modalImage.alt}
                style={{
                  maxWidth: '100%',
                  maxHeight: '70vh',
                  objectFit: 'contain',
                }}
              />
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default RealtimeImageModal;
